export default __webpack_public_path__ + "static/media/GUM-BNB.39697e18.svg";